

























































import { Vue, Component } from 'vue-property-decorator';
import CampaignAddComp from '@/components/CampaignAddComponent.vue';
import { COLLECTION_CAMPAIGNADDS } from '@/model/AppConstants';
import PermUtil from '@/model/PermUtil';

@Component({
  components: {
    CampaignAddComp,
  },
})
export default class CompaignPage extends Vue {
  mounted() {
    this.$store.dispatch('bindCampaignAdd');
  }

  get campaignAdds() {
    return this.$store.state.campaignAdds;
  }

  get canCreate() {
    return PermUtil.canCreateCampAdd();
  }

  deleted(camp: any) {
    this.$store.dispatch('removeFromCollection', {
      collection: COLLECTION_CAMPAIGNADDS,
      payload: camp.id,
    });
  }

  get freshCurrentUser() {
    return this.$store.state.freshCurrentUser;
  }
}
